export function shouldScopePedidosToMedicoUser(user) {
  if (!user) return false;
  if (user.isAdmin === true || user.superAdminBypass) return false;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  if (!perms.includes('ver_pedido_recetas_medico')) return false;
  if (perms.includes('ver_gestion_derivacion')) return false;
  return true;
}

export function resolveLinkedMedicoIdFromUser(user) {
  const id = Number(user?.medico_id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function pedidoBelongsToLinkedMedico(pedido, linkedMedicoId, scoped) {
  if (!scoped) return true;
  if (!linkedMedicoId) return false;
  return Number(pedido?.medico_id) === Number(linkedMedicoId);
}

export function filterPedidosForMedicoUser(pedidos, user, linkedMedicoIdOverride) {
  const scoped = shouldScopePedidosToMedicoUser(user);
  if (!scoped) return Array.isArray(pedidos) ? pedidos : [];
  const linked = linkedMedicoIdOverride ?? resolveLinkedMedicoIdFromUser(user);
  if (!linked) {
    // El backend ya filtra por médico de sesión; no vaciar la bandeja mientras sincroniza el vínculo local.
    return Array.isArray(pedidos) ? pedidos : [];
  }
  return (Array.isArray(pedidos) ? pedidos : []).filter((p) => Number(p.medico_id) === linked);
}

export function countPedidosForMedicoUser(pedidos, user, linkedMedicoIdOverride) {
  return filterPedidosForMedicoUser(pedidos, user, linkedMedicoIdOverride).length;
}
